import { BuildClass, Do, fsmData, timer } from '../../universal';
import { $, React, _ } from '../lib';
import { switchFacilityNew } from './component-facility-switcher';
import { j2h } from './component-j2h';
import { J2rLoadingSpinner, J2rTooltip, j2r, j2rtxt, reactRender, } from './component-react';
import { TOGLOB, trionlineAjax } from './component-trionline';
import { moment } from './moment-wrapper';
import { Bindings, CJSX, ConditionalObject, ContextMenuWrapper, } from './ui5';
import { WindowManagerToolbar, WindowManagerUI, } from './window-manager';
export const latestRefresh = { ts: moment().format('YYYY-MM-DD-HH-mm-ss') };
const mapping = () => ({
    '/': window.rootData?.Session?.User ? 'openPageDashboard' : 'openLoginPage',
    '/roster/': 'roster.openNavRoster',
    '/roster/employee/': 'openNavEmployeeRoster',
    '/roster/settings/': 'openNavRosterSettings',
    '/billing/': 'billing.openNavBilling',
    '/billing/cdc-budget/': 'billing.openNavBillingBudget',
    '/billing/agreements/': 'billing.openNavRIWStandalone',
    '/timeclock/': 'openNavTimeclock',
    '/admin/backup-browser/': 'openNavBackupBrowser',
    '/admin/stp-approval-permissions/': 'openNavSTPApprovalPermissions',
    '/iris/': 'openNavIRISControlPanel',
    '/errors/': 'errors.openNavErrorManager',
    '/admin/clone-facility/': 'openNavCloneFacility',
    '/users/': 'openNavUserList',
    '/users-new/': 'users.openNavUserList',
    '/admin/demo/': 'openNavDemoUsers',
    '/download/': 'openNavDownloadPage',
    '/payroll/stp/': 'openNavKBSnippet',
    '/acct/': 'openNavAccountPage',
    '/payroll/stp/approve/': 'openNavSTPApprovals',
    '/privacy/': 'openNavKBSnippet',
    '/terms/': 'openNavKBSnippet',
    '/admin/sql/': 'websql.openNavWebSQL',
    '/admin/handles/': 'openNavHandles',
    '/admin/facility-list/': 'openFacilityList',
    '/payroll/payslips/': 'openNavPayslips',
    '/tms/': 'tms.openNavTMS',
    '/help/': 'openNavHelpPage',
    '/payroll/': 'payroll.openNavPayroll',
    '/payroll/onboarding/': 'payroll.openNavOnboarding',
    '/kb/': 'openNavKBRoot',
    '/crm/': 'crm.openNavCRM',
    '/hr/': 'hr.openNavHR',
    '/kb/<snippet>/': 'openNavKBSnippet',
    '/bulletins/view/<bulletin>/': 'openNavKBSnippet',
    '/leave/applications/': 'openNavLeaveApplications',
    '/payroll/queries/': 'openNavPayQueries',
    '/leave/scheduled/': 'openNavScheduledLeave',
    '/roster/clockings/': 'openNavClockings',
    '/bulletins/': 'openNavBulletin',
    '/mfa-elevation/': 'openMFALoginForm',
    '/forced-password-change/': 'openForcedPasswordChangeForm',
    '/acct/new-password/': 'openResetPassword',
    '/admin/notification-editor/': 'openNavNotificationEditor',
    '/screenshare/': 'openNavScreenShare',
    '/leave/accrued/': 'openAccruedLeave',
    '/admin/schema-details/<database>/': 'openNavSchemaDetails',
    '/hr/onboard/': 'employee.openEmployeeOnboard',
    '/search-index/': 'openNavSearchIndex',
    '/settings/roles/': 'openNavManagementRoles',
    '/api/unsubscribe/<token>/': 'openEmailUnsubscribe',
    '/polls/': 'openNavPollManager',
    '/polls/<pollcode>/': 'openNavPolls',
    '/admin/invoicing/': 'openInvoiceMetrics',
    '/qfr-charts/': 'openNavQFRCharts',
    '/hr/employee/': 'employee.openNavEmployee',
    '/hr/employee/chat/': 'employee.openNavEmployee',
    '/hr/employee/appraisals/': 'employee.openNavEmployee',
    '/hr/employee/appraisals/<appraisal>/': 'employee.openNavEmployee',
    '/hr/onboarding/': 'employee.openOnboarding',
    '/client-portal/': 'openNavClientPortal',
    '/client-portal/service/<key>/': 'openNavClientPortal',
    '/client-portal/scheduler/': 'openNavClientPortal',
    '/client-portal/employee/<key>/': 'openNavClientPortal',
    '/client-portal/feedback/<key>/': 'openNavClientPortal',
    '/client-portal/cancel/<key>/': 'openNavClientPortal',
    '/client-portal/all-feedback/': 'openNavClientPortal',
    '/client-portal/request/<key>/': 'openNavClientPortal',
    '/client-portal/all-requests/': 'openNavClientPortal',
});
const indexedNewFramePages = () => {
    const mappingCompiled = _.map(mapping(), (fn, pattern) => {
        pattern = pattern.replace(/\//g, '\\/');
        const params = [];
        _.forEach(pattern.match(/<.*?>/g), grp => {
            pattern = pattern.replace(grp, '(.*?)');
            params.push(grp.substring(1, grp.length - 1));
        });
        return {
            pattern: new RegExp(`^${pattern}$`),
            handler: getFunctionFromString(fn),
            params,
        };
    });
    return mappingCompiled;
};
const getFunctionFromString = (fnString) => {
    let namespace = window;
    let failed = false;
    fnString.split('.').forEach(x => {
        if (namespace != null && x in namespace) {
            namespace = namespace[x];
        }
        else {
            failed = true;
        }
    });
    if (failed) {
        return null;
    }
    return namespace;
};
const getHandlerForURL = (url) => {
    let match = null;
    _.forEach(indexedNewFramePages(), route => {
        const results = url.match(route.pattern);
        if (results == null) {
            return undefined;
        }
        const params = {};
        results.slice(1).forEach((val, index) => {
            const key = route.params[index];
            if (key != null) {
                params[key] = val;
            }
        });
        match = {
            fn: route.handler,
            params,
        };
        return false;
    });
    if (match != null) {
        return match;
    }
    const urlWithoutHash = url.split('#')[0];
    if (urlWithoutHash && urlWithoutHash !== url) {
        return getHandlerForURL(urlWithoutHash);
    }
    const urlWithoutQuery = url.split('?')[0];
    if (urlWithoutQuery && urlWithoutQuery !== url) {
        return getHandlerForURL(urlWithoutQuery);
    }
    return null;
};
const getUrlParts = (url = location.href || '') => {
    const prefix = `${location.protocol}//${location.host}`;
    let processedUrl = url;
    if (location.href.startsWith(prefix)) {
        processedUrl = url.substring(prefix.length);
    }
    const [path, raw_args] = processedUrl.split('?', 2);
    const args = {};
    (raw_args ?? '').split('&').forEach(x => {
        const [key, val] = x?.split('=');
        if (key != null && val != null) {
            args[key] = decodeURIComponent(val);
        }
    });
    return { url: processedUrl, path: path, args };
};
const checkBrowserCompatibility = () => {
    try {
        const set = new Set([1, 2, 3]);
        Array.from(set);
        const nodes = document.querySelectorAll('*');
        nodes.forEach(() => { });
        const promise1 = Promise.resolve(3);
        const promise2 = new Promise(resolve => {
            resolve(1);
        });
        Promise.all([promise1, promise2]).then(() => { });
        return true;
    }
    catch (error) {
        return false;
    }
};
export const createUI2018 = () => {
    if (navigator.userAgent.indexOf('Trident') !== -1) {
        showIEErrorPage();
        return;
    }
    if (!checkBrowserCompatibility()) {
        showOutdatedBrowserPage();
        return;
    }
    {
        let data;
        const el = document.querySelector('#dataPackage');
        const dataRaw = el.value;
        el.remove();
        try {
            data = JSON.parse(dataRaw);
        }
        catch (error) {
            console.error(`Could not decode JSON: ${dataRaw}`);
            data = {};
        }
        window.rootData = _.assign(data, { UrlParts: getUrlParts() });
    }
    const htmlElement = document.querySelector('html');
    if (htmlElement) {
        htmlElement.classList.add('react');
    }
    document.body.classList.remove('capped_width');
    document.body.classList.add('react');
    document.body.innerText = '';
    document.body.appendChild(j2h({ class: 'ui-root' }));
    document.body.appendChild(j2h({ attr: { id: 'modal-container' } }));
    let { url } = getUrlParts();
    pageStateReplace(_.cloneDeep(window.rootData), url);
    const is_redirecting = Do(() => {
        const D = window.rootData.Page ?? {};
        return D['mfaLogin'] || D['pwdChange'];
    });
    let props = {
        tag: TriOnlineRoot,
        sidebar: window.rootData.Sidebar,
        switcher: window.rootData.Switcher,
        session: window.rootData.Session,
        path: url,
        content: null,
        toolbar: null,
        transparentBackground: false,
        windowManager: null,
    };
    const content = getContentFromURL();
    if (!is_redirecting && (content == null || !content.fn)) {
        timer(() => {
            throw new Error(`Cannot get content for ${location.pathname}`);
        });
    }
    props = _.assign({}, props, fixPageState(content.fn?.(content.params) ?? {}));
    const htmlEl = document.querySelector('html');
    if (props.transparentBackground && htmlEl) {
        htmlEl.classList.add('transBG');
    }
    if (props.windowManager != null && htmlEl) {
        htmlEl.classList.add('window-manager');
    }
    const rootEl = document.querySelector('.ui-root');
    if (!rootEl) {
        throw new Error('Cannot find .ui-root element');
    }
    reactRender(rootEl, j2r(props)).then(() => {
        timer(() => window.rootUI.updateSidebarExpansion());
        window.rootUI.refreshTheme();
        window.addEventListener('resize', () => {
            if (document.body !== null) {
                window.rootUI.setState({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                });
            }
        });
        timer(() => {
            TOGLOB.$lock = $('.toPageLock')
                .toArray()
                .map(x => $(x));
        });
        if (window.rootData.Page?.['mfaLogin']) {
            url = `/mfa-elevation/?rd=${encodeURI(location.pathname)}`;
            openNavLinkMaybe(url, true);
        }
        if (window.rootData.Page?.['pwdChange']) {
            url = `/forced-password-change/?rd=${encodeURI(location.pathname)}`;
            openNavLinkMaybe(url, true);
            return;
        }
    });
};
class TriOnlineRoot extends React.Component {
    content;
    wmanagerToolbar;
    customToolbar;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.closeContextMenu,
            this.getResponsiveClassName,
            this.setContextMenu,
        ]);
        window.rootUI = this;
        this.content = React.createRef();
        this.wmanagerToolbar = React.createRef();
        this.customToolbar = React.createRef();
        this.state = {
            width: document.body.clientWidth,
            height: document.body.clientHeight,
            searchText: '',
            content: this.props.content ?? (() => null),
            windowManager: this.props.windowManager ?? null,
            legacyFrame: this.props.legacyFrame ?? null,
            contextMenu: null,
            toolbar: this.props.toolbar ?? null,
            path: this.props.path ?? '/',
            sidebar: this.props.sidebar,
            sidebarOverride: this.props.sidebarOverride,
            switcher: this.props.switcher,
            session: this.props.session,
            notificationCount: this.props.notificationCount ?? 0,
            showSearch: this.props.showSearch ?? null,
            contentPadding: this.props.contentPadding ?? true,
            cappedWidth: this.props.cappedWidth ?? false,
            transparentBackground: this.props.transparentBackground ?? false,
            hideSidebar: this.props.hideSidebar ?? false,
            hideFooter: this.props.hideFooter ?? false,
            hideTopNav: this.props.hideTopNav ?? false,
            collapseToIcon: this.props.collapseToIcon ?? false,
            theme: this.props.theme ?? 'green',
            appName: this.props.appName ?? 'main',
            expandedSidebar: this.props.expandedSidebar ?? null,
            sidebarOpen: false,
            kebabOpen: false,
        };
        this.setScrolling();
    }
    render() {
        if (this.isProd()) {
            return this.buildFrame();
        }
        return React.createElement(React.StrictMode, null, this.buildFrame());
    }
    isProd() {
        if (['127.0.0.1', 'dev.localhost', '127.0.0.1:8001'].includes(location.host)) {
            return false;
        }
        const h = location.host.split('.');
        if (h.length === 3) {
            return true;
        }
        return h[0] != null && !['dev', 'dan', 'dean', 'rob'].includes(h[0]);
    }
    buildFrame() {
        return (React.createElement("div", { className: BuildClass({
                'ui-root-inner': true,
                [this.getResponsiveClassName()]: true,
                [this.state.theme ?? 'green']: true,
                'hide-top-nav': this.state.hideTopNav,
                transBG: this.state.transparentBackground,
            }) },
            React.createElement("div", { id: "hub_wrapper", className: BuildClass({
                    capped_width: this.state.cappedWidth,
                }) },
                this.buildToolbar(),
                this.state.session?.User != null ? this.buildSidebar() : undefined,
                React.createElement("div", { id: "hub_body", className: BuildClass({
                        [this.getResponsiveClassName()]: true,
                        'no-footer': this.state.hideFooter,
                        'hidden-sidebar': this.state.hideSidebar ||
                            this.state.session?.User == null,
                    }) },
                    this.buildContent(),
                    this.buildFooter()),
                React.createElement("div", { className: BuildClass({
                        toPageLockTransparent: true,
                        hamburger: true,
                        active: this.state.sidebarOpen,
                    }), onClick: () => {
                        this.setState({
                            kebabOpen: false,
                            sidebarOpen: false,
                        }, () => {
                            this.setScrolling();
                        });
                    } })),
            this.state.contextMenu && (React.createElement(ContextMenuWrapper, { data: this.state.contextMenu, onClose: this.closeContextMenu })),
            React.createElement("div", { className: "toPageLock", id: "trionline_pagelock" }),
            React.createElement("div", { className: "toPageLock", id: "trionline_pagelock_2" }),
            React.createElement("div", { className: "toPageLock", id: "trionline_pagelock_3" }),
            React.createElement("div", { className: "toPageLock", id: "trionline_pagelock_4" }),
            React.createElement("div", { className: "toPageLock", id: "trionline_pagelock_5" })));
    }
    setScrolling() {
        const clist = document.documentElement.classList;
        const clstr = 'no-scroll';
        const currently_disabled = clist.contains(clstr);
        const should_be_disabled = this.state.sidebarOpen || this.state.kebabOpen;
        if (should_be_disabled && !currently_disabled) {
            document.body.addEventListener('touchscroll', disablePageScroll);
            document.body.addEventListener('scroll', disablePageScroll);
        }
        else if (currently_disabled && !should_be_disabled) {
            document.body.removeEventListener('touchscroll', disablePageScroll);
            document.body.removeEventListener('scroll', disablePageScroll);
        }
    }
    getResponsiveClassName() {
        const thresholds = [1275, 1025, 490];
        const w = this.state.width;
        return Do(() => {
            if (w >= thresholds[0]) {
                return 'wide';
            }
            else if (w < thresholds[0] && w >= thresholds[1]) {
                return 'condensed';
            }
            else if (w < thresholds[1] && w >= thresholds[2]) {
                return 'tablet';
            }
            else if (w < thresholds[2]) {
                return 'mobile';
            }
            return 'wide';
        });
    }
    buildToolbar() {
        return (React.createElement("div", { id: "hub_toolbar", className: BuildClass({
                [this.getResponsiveClassName()]: true,
                noselect: true,
            }) },
            j2r({
                tag: J2rTooltip,
                key: 'hamburger',
                elTag: 'a',
                title: 'Toggle Sidebar',
                cl: BuildClass({
                    hover: true,
                    visible: this.state.hideSidebar,
                }),
                id: 'hub_hamburger',
                content: [
                    {
                        tag: 'img',
                        key: 'img',
                        alt: 'Menu',
                        src: Do(() => {
                            if (this.state.sidebarOpen) {
                                return '/static/img/svg/hamburger-back.svg';
                            }
                            return '/static/img/svg/hamburger.svg';
                        }),
                    },
                ],
                onClick: (e) => {
                    e.preventDefault();
                    this.setState({
                        sidebarOpen: !this.state.sidebarOpen,
                    }, () => {
                        this.setScrolling();
                    });
                },
            }),
            j2r({
                tag: J2rTooltip,
                key: 'logo',
                elTag: 'a',
                title: 'TriOnline Home Page',
                cl: BuildClass({
                    hover: true,
                    collapsible: this.state.collapseToIcon,
                }),
                id: 'hub_logo',
                href: '/',
                onClick: appLinkEv,
                content: [
                    {
                        tag: 'img',
                        key: 'img',
                        src: Do(() => {
                            if (window.innerWidth <= 768 &&
                                this.state.collapseToIcon) {
                                return '/static/img/svg/favicon.svg';
                            }
                            else if (this.state.theme === 'black') {
                                return '/static/img/svg/trionline-white.svg';
                            }
                            return '/static/img/svg/trionline.svg';
                        }),
                        alt: 'TriOnline',
                    },
                ],
            }),
            React.createElement("span", { id: "hub_search", className: "buttons" },
                ConditionalObject(this.state.windowManager != null &&
                    this.content.current?.state?.hasInitModel, React.createElement(WindowManagerToolbar, { key: "wmanage-toolbar", ref: this.wmanagerToolbar, wmanager: this.content.current })),
                ConditionalObject(this.state.toolbar != null, () => {
                    const toolbar = this.state.toolbar;
                    if (!toolbar) {
                        return null;
                    }
                    const tb = j2r(toolbar());
                    if (!React.isValidElement(tb)) {
                        return tb;
                    }
                    const tbProps = tb.props;
                    const tbClass = typeof tbProps['cl'] === 'string'
                        ? tbProps['cl']
                        : typeof tbProps['className'] === 'string'
                            ? tbProps['className']
                            : '';
                    return React.cloneElement(tb, {
                        className: BuildClass(tbClass
                            ? { 'custom-toolbar': true, [tbClass]: true }
                            : { 'custom-toolbar': true }),
                        key: 'custom-toolbar',
                        ref: this.customToolbar,
                    });
                }),
                ConditionalObject(this.state.showSearch === true, React.createElement("input", { type: "text", id: "hub_search_q", value: this.state.searchText, placeholder: "Click to search...", onChange: (e) => {
                        this.setState({ searchText: e.target.value });
                    } }))),
            ConditionalObject(this.state.session?.User != null, j2r({
                tag: J2rTooltip,
                key: 'notifications',
                elTag: 'span',
                title: 'Notifications',
                id: 'hub_notification_count',
                cl: BuildClass({
                    'toolbar-icon': true,
                    hover: true,
                    zero: this.state.notificationCount === 0,
                }),
                content: [
                    this.state.notificationCount > 0
                        ? {
                            tag: 'span',
                            cl: 'count',
                            key: 'count',
                            text: this.state.notificationCount,
                        }
                        : {
                            tag: 'img',
                            cl: 'notification-icon',
                            key: 'notification-icon',
                            alt: 'Notifications',
                            src: '/static/img/svg/small-notification-bell.svg',
                        },
                ],
                onClick: () => {
                    openNotificationFlyout();
                },
            })),
            j2r({
                tag: J2rTooltip,
                key: 'kebab-menu-icon',
                elTag: 'span',
                title: 'Global Menu',
                id: 'kebab-menu-icon',
                cl: BuildClass({
                    'toolbar-icon': true,
                    hover: true,
                    zero: this.state.notificationCount === 0,
                }),
                content: [
                    {
                        tag: 'img',
                        cl: 'kebab',
                        key: 'kebab',
                        alt: 'Menu',
                        src: '/static/img/svg/kebab-main.svg',
                    },
                ],
                onClick: () => {
                    this.setState({
                        kebabOpen: !this.state.kebabOpen,
                    }, () => {
                        this.setScrolling();
                    });
                },
            }),
            ConditionalObject(this.state.session?.User != null, j2r({
                tag: J2rTooltip,
                key: 'user',
                elTag: 'a',
                title: `Click to view account page for ${this.state.session?.Name ?? ''}`,
                cl: 'hover',
                id: 'hub_acct',
                href: '/acct/',
                onClick: appLinkEv,
                content: this.state.session?.Name ?? '',
            })),
            this.buildKebabMenu(),
            React.createElement("div", { className: BuildClass({
                    toPageLockTransparent: true,
                    kebab: true,
                    active: this.state.kebabOpen,
                }), onClick: () => {
                    this.setState({
                        kebabOpen: false,
                        sidebarOpen: false,
                    }, () => {
                        this.setScrolling();
                    });
                } })));
    }
    buildKebabMenu() {
        const link = (txt, img, link, click) => (React.createElement("a", { key: `${txt}${link}`, href: link ?? undefined, onClick: e => {
                if (link == null) {
                    e.preventDefault();
                }
                ;
                (click ?? appLinkEv)(e);
            }, title: txt },
            React.createElement("img", { alt: `Icon for ${txt}`, src: `/static/img${img}` }),
            React.createElement("span", null, txt)));
        return (React.createElement("div", { key: "kebab-menu", className: BuildClass({
                'kebab-menu': true,
                shadow_large: true,
                visible: this.state.kebabOpen,
                'no-user': this.state.session?.User == null,
            }) },
            React.createElement(CJSX, { cond: this.state.session?.User != null },
                link(`${this.state.notificationCount} notification${this.state.notificationCount === 1 ? '' : 's'}`, '/svg/small-notification-bell.svg', undefined, () => {
                    this.setState({ kebabOpen: false }, () => {
                        this.setScrolling();
                        timer(() => {
                            openNotificationFlyout();
                        });
                    });
                }),
                link(this.getFacilityName(), '/svg/small-house-icon.svg', undefined, () => {
                    this.setState({ kebabOpen: false }, () => {
                        this.setScrolling();
                        if (this.props.session?.User != null) {
                            timer(() => {
                                switchFacilityNew();
                            });
                        }
                    });
                }),
                link('My Account', '/svg/small-person-icon.svg', '/acct/')),
            React.createElement(CJSX, { cond: this.state.session?.User == null }, link('Sign In', '/svg/small-person-icon.svg', '/')),
            link('Refresh', '/svg/small-refresh-icon.svg', undefined, () => {
                location.reload();
            }),
            link('Help', '/svg/small-help-icon.svg', '/help/'),
            React.createElement(CJSX, { cond: this.state.session?.User != null }, link('Sign Out', '/svg/small-door-icon.svg', '/login/logout/'))));
    }
    buildSidebar() {
        return (React.createElement(TriOnlineFrameSidebar, { key: "sidebar", expandedSidebar: this.state.expandedSidebar, getResponsiveClassName: this.getResponsiveClassName, hideSidebar: this.state.hideSidebar, sidebar: this.state.sidebar, sidebarOpen: this.state.sidebarOpen, sidebarOverride: this.state.sidebarOverride ?? null, onToggleExpanded: v => {
                this.setState({ expandedSidebar: v });
            } }));
    }
    buildFooter() {
        return (React.createElement("div", { id: "hub_footer", className: BuildClass({
                noselect: true,
                'no-footer': this.state.hideFooter,
                'hidden-sidebar': this.state.hideSidebar || this.state.session?.User == null,
            }) },
            React.createElement("span", { id: "hub_footer_logos", className: "nomobile" },
                j2r({
                    tag: J2rTooltip,
                    key: 'tm-logo-outer',
                    elTag: 'a',
                    title: 'Click to go to Trimicro.com.au',
                    href: 'http://trimicro.com.au',
                    target: '_blank',
                    rel: 'noopener',
                    content: [
                        j2rtxt('copyright', '©'),
                        {
                            tag: 'img',
                            key: 'tm-logo',
                            alt: 'TriMicro logo',
                            src: '/static/img/trimicro-logo-footer.png',
                        },
                    ],
                }),
                j2r({
                    tag: J2rTooltip,
                    key: 'sn-logo-outer',
                    elTag: 'a',
                    title: 'Click to go to SoftwareNorth.com.au',
                    cl: 'less-needed',
                    href: 'http://softwarenorth.com.au',
                    target: '_blank',
                    rel: 'noopener',
                    content: ' by Software North',
                })),
            j2r({
                tag: J2rTooltip,
                key: 'hub_facility_selector',
                elTag: 'span',
                title: this.state.session?.User != null ? 'Facility Switcher' : '',
                id: 'hub_facility_selector',
                content: _.compact([
                    Do(() => {
                        const title = this.getFacilityName();
                        if (this.state.session?.User == null) {
                            return null;
                        }
                        return {
                            id: 'admin_choice',
                            key: 'admin_choice',
                            title,
                            children: [
                                j2rtxt('txt', title),
                                {
                                    tag: 'img',
                                    key: 'arrow',
                                    alt: 'Arrow',
                                    src: '/static/img/svg/triangle-down.svg',
                                },
                            ],
                            onClick: () => {
                                switchFacilityNew();
                            },
                        };
                    }),
                ]),
            }),
            React.createElement("span", { id: "hub_footer_links" },
                React.createElement("a", { href: "/help/", onClick: appLinkEv }, "Help"),
                React.createElement("a", { className: "less-needed", href: "/privacy/", onClick: appLinkEv }, "Privacy"),
                ConditionalObject(this.state.session?.User == null, React.createElement("a", { className: "less-needed", href: "/terms/", onClick: appLinkEv }, "Terms")),
                ConditionalObject(this.state.session?.User != null, React.createElement("a", { className: "less-needed", href: "/feedback/", onClick: appLinkEv }, "Feedback")),
                Do(() => {
                    if (this.state.session?.User != null) {
                        return (React.createElement("a", { href: "/login/logout/", id: "href_sign_out", onClick: appLinkEv }, "Sign Out"));
                    }
                    else if (location.pathname !== '/') {
                        return (React.createElement("a", { href: "/", id: "href_sign_out", onClick: appLinkEv }, "Sign In"));
                    }
                    return undefined;
                }))));
    }
    getFacilityName() {
        if (this.state.switcher == null) {
            return 'Not signed in';
        }
        const [fac, srost] = this.state.switcher.current;
        const facility = fsmData(this.state.switcher.facilities, {
            filter: x => x[0] === fac,
            map: x => x?.[1],
            takeFirst: true,
        });
        const subroster = fsmData(this.state.switcher.rosters, {
            filter: x => x[0] === fac && x[1] === srost,
            map: x => x?.[2],
            takeFirst: true,
        });
        return Do(() => {
            if (facility == null) {
                return 'Not signed in';
            }
            else if (subroster != null) {
                return `${fac}: ${facility} - ${subroster}`;
            }
            return `${fac}: ${facility}`;
        });
    }
    buildContent() {
        return (React.createElement("main", { id: "hub_content", className: BuildClass({
                padding: this.state.contentPadding,
                loading: !(this.state.legacyFrame != null || this.state.content != null),
                'no-footer': this.state.hideFooter,
            }) }, j2r(() => {
            if (this.state.legacyFrame != null) {
                return (React.createElement(LegacyWrapperComponent, { key: "legacy-wrapper", ref: this.content, onCreate: this.state.legacyFrame.onCreate, onDestroy: this.state.legacyFrame.onDestroy }));
            }
            else if (this.state.windowManager != null) {
                return (React.createElement(WindowManagerUI, { ref: this.content, key: "content-inner-wmanager", parent: this, toolbar: this.wmanagerToolbar.current, mobile: this.getResponsiveClassName() === 'mobile', options: this.state.windowManager }));
            }
            else if (this.state.content == null) {
                return React.createElement(J2rLoadingSpinner, { size: "large", key: "loading-content" });
            }
            return _.assign({}, this.state.content(), {
                key: 'content-inner',
                ref: this.content,
            });
        })));
    }
    toggleCappedWidth() {
        this.setState(s => ({ cappedWidth: !s.cappedWidth }));
    }
    toggleSideBar() {
        this.setState(s => ({ hideSidebar: !s.hideSidebar }));
    }
    updateSidebarExpansion() {
        if (this.state.sidebar) {
            _.forEach(this.state.sidebar, item => {
                const selected = _.filter(item.Children, s => compareLinks(s.Link, location.pathname));
                if (this.state.expandedSidebar !== item.Label && selected.length > 0) {
                    this.setState(s => ({
                        expandedSidebar: Do(() => {
                            if (s.expandedSidebar === item.Label) {
                                return null;
                            }
                            return item.Label;
                        }),
                    }));
                }
            });
        }
    }
    changePage(pageState) {
        const htmlEl = document.querySelector('html');
        if (pageState.transparentBackground && htmlEl) {
            htmlEl.classList.add('transBG');
        }
        if (pageState.windowManager != null && htmlEl) {
            htmlEl.classList.add('window-manager');
        }
        document.title = `${window.rootData.Title} | TriOnline`;
        const delta = _.assign({}, fixPageState(pageState), { path: getUrlParts().url });
        this.setState(prevState => {
            const updated = { ...prevState };
            _.keys(delta).forEach(key => {
                const k = key;
                if (k in prevState) {
                    ;
                    updated[k] = delta[key];
                }
            });
            return updated;
        }, () => {
            this.refreshTheme();
            refreshAppMetaData(this.state.appName);
            navigator.serviceWorker?.getRegistration().then(async (reg) => {
                if (reg) {
                    reg.getNotifications().then(notifications => {
                        notifications.forEach(N => {
                            if (location.pathname === N.tag) {
                                N.close();
                            }
                        });
                    });
                }
            });
        });
    }
    setContextMenu(obj) {
        this.setState({ contextMenu: obj });
    }
    changeTheme(theme) {
        this.setState({ theme }, () => {
            this.refreshTheme();
        });
    }
    refreshTheme() {
        if (this.state.theme === 'black') {
            document.body.classList.add('black');
        }
        else {
            document.body.classList.remove('black');
        }
    }
    closeContextMenu() {
        this.setState({ contextMenu: null });
    }
    NewWindow(fn, params, cb) {
        const fnBase = contentComponent()?.NewWindow;
        if (fnBase == null) {
            timer(() => {
                throw new Error('Cannot open a new window with current page state');
            });
        }
        fnBase(fn, params, cb);
    }
}
export const contentComponent = () => window.rootUI?.content.current;
export const openWindow = (fn, params, cb) => {
    if (window.rootUI == null) {
        timer(() => {
            throw new Error('Cannot open a new window without new frame');
        });
    }
    window.rootUI?.NewWindow(fn, params, cb);
};
class LegacyWrapperComponent extends React.Component {
    wrapper;
    constructor(props) {
        super(props);
        this.wrapper = React.createRef();
    }
    componentDidMount() {
        if (this.wrapper.current) {
            this.wrapper.current.innerText = '';
            this.props.onCreate?.(this.wrapper.current, window.rootData, this);
        }
    }
    componentWillUnmount() {
        if (this.wrapper.current) {
            this.props.onDestroy?.(this.wrapper.current, window.rootData, this);
            this.wrapper.current.innerText = '';
        }
    }
    render() {
        return React.createElement("div", { className: "legacy-wrapper", id: "legacy-wrapper", ref: this.wrapper });
    }
}
export const appLinkEv = (ev) => {
    const new_tab = ev.button === 1 || ev.ctrlKey || ev.shiftKey;
    const link = ev.currentTarget.href;
    if (link == null) {
        ev.preventDefault();
        return;
    }
    openNavLinkMaybe(link, false, ev, new_tab);
};
export const mutateLinksForApplication = (link) => {
    const link2 = `${link}/`;
    const handler1 = getHandlerForURL(link);
    const handler2 = getHandlerForURL(link2);
    if (handler1 != null) {
        return [true, link];
    }
    else if (handler2 != null) {
        return [true, link2];
    }
    return [false, link];
};
const compareLinks = (a, b) => {
    if (a == null || b == null) {
        return false;
    }
    const parse = (x) => (x.slice(-1)[0] === '/' ? x.slice(0, -1) : x);
    return parse(a) === parse(b);
};
const getContentFromURL = (link = location.pathname) => {
    if (window.rootData.Error != null) {
        return {
            params: null,
            fn: () => ({
                cappedWidth: true,
                content: () => ({
                    cl: 'error-frame',
                    children: [
                        {
                            tag: 'h1',
                            key: 'title',
                            text: window.rootData.Title,
                        },
                        {
                            cl: 'error_msg_2',
                            key: 'err',
                            text: window.rootData.Error,
                        },
                    ],
                }),
            }),
        };
    }
    return (getHandlerForURL(link) ?? {
        params: null,
        fn: () => ({
            content: () => ({
                cl: 'error_msg_2 cntr',
                key: 'stub',
                text: 'Unknown URL for React Wrapper',
            }),
        }),
    });
};
export const openNavLinkMaybe = (link, replacing, ev, new_tab) => {
    const prefix = `${location.protocol}//${location.host}`;
    if (link.slice(0, prefix.length) === prefix) {
        link = link.slice(prefix.length);
    }
    const [is_app, url] = mutateLinksForApplication(link);
    if (is_app) {
        ev?.preventDefault();
        if (new_tab) {
            window.open(url);
        }
        else {
            openNavLink(url, replacing);
        }
    }
    else {
        location.href = url;
    }
};
export const openNavLink = (linkOrig, replacing = false, err_count = 0) => {
    const [is_app, link] = mutateLinksForApplication(linkOrig);
    if (!is_app) {
        timer(() => {
            throw new Error(`Invalid link ${link}`);
        });
        timer(1000, () => {
            openNavLinkMaybe(link);
        });
        return;
    }
    if (err_count > 5) {
        window.rootUI.changePage({
            cappedWidth: true,
            content: () => ({
                cl: 'error-frame',
                children: [
                    {
                        tag: 'h1',
                        key: 'title',
                        text: 'Offline',
                    },
                    {
                        cl: 'error_msg_2',
                        key: 'err',
                        text: 'Cannot connect to TriOnline right now. Please check your internet connection.',
                    },
                ],
            }),
        });
        return;
    }
    window.rootUI.setState({
        content: null,
        legacyFrame: null,
        windowManager: null,
        contextMenu: null,
        sidebarOpen: false,
        kebabOpen: false,
        transparentBackground: false,
    }, () => window.rootUI.setScrolling());
    const htmlEl = document.querySelector('html');
    if (htmlEl != null) {
        const htmlCl = htmlEl.classList;
        htmlCl.remove('transBG');
        htmlCl.remove('window-manager');
    }
    if (replacing) {
        pageStateReplace(_.cloneDeep(window.rootData), link);
    }
    else {
        pageStatePush(_.cloneDeep(window.rootData), link);
    }
    let url;
    {
        const urlPart = link.split('#')[0];
        if (urlPart != null) {
            url = urlPart.includes('?') ? `${urlPart}&apionly=1` : `${urlPart}?apionly=1`;
            url += `&latest=${latestRefresh.ts}`;
        }
        else {
            url = `${link}?apionly=1&latest=${latestRefresh.ts}`;
        }
    }
    trionlineAjax({
        url: url,
        any: xhttp => {
            const data = xhttp.responseText;
            if (data == 'TOKEN_PAGE_REFRESH_NEEDED') {
                console.log('Application updated, refreshing');
                location.href = linkOrig;
                return;
            }
            let dataObj = null;
            try {
                dataObj = JSON.parse(data);
            }
            catch (error) { }
            if (data == null || xhttp.status >= 500 || dataObj == null) {
                openNavLink(linkOrig, replacing, err_count + 1);
            }
            changePageOuter(link, dataObj);
        },
    });
};
const changePageOuter = async (link, dataObj) => {
    window.rootData = _.assign(dataObj, {
        UrlParts: getUrlParts(link),
    });
    pageStateReplace(_.cloneDeep(window.rootData), link);
    window.rootUI.updateSidebarExpansion();
    Array.from(document.querySelectorAll('link.page-style')).forEach(x => {
        x.remove();
    });
    return Promise.all([
        addStylesToPage(window.rootData?.Assets?.Style ?? []),
        addScriptsToPage(window.rootData?.Assets?.Script ?? []),
    ])
        .then(() => {
        let url;
        const handler = getContentFromURL(link);
        if (handler == null) {
            console.info('Forcing page refresh from invalid handler found from content URL');
            location.reload();
        }
        if (window.rootData.Page?.['mfaLogin']) {
            url = `/mfa-elevation/?rd=${encodeURI(location.pathname)}`;
            openNavLinkMaybe(url, true);
        }
        else if (window.rootData.Page?.['pwdChange']) {
            url = `/forced-password-change/?rd=${encodeURI(location.pathname)}`;
            openNavLinkMaybe(url, true);
        }
        else if (!handler.fn) {
            console.error(`No handler found for ${link}`);
            location.reload();
        }
        else {
            const fnResult = handler.fn();
            window.rootUI.changePage(fnResult);
        }
    })
        .catch(err => {
        console.error(err);
    });
};
export const addScriptsToPage = async (scripts) => {
    const script_urls = _.map(scripts, x => {
        const prefix_char = x.indexOf('?') === -1 ? '?' : '&';
        x += `${prefix_char}_t=${window.rootData.Version}`;
        if (x[0] === '/') {
            x = `${location.protocol}//${location.host}${x}`;
        }
        return x;
    });
    const getEls = (q) => Array.from(document.querySelectorAll(q));
    const existing_scripts = getEls('script').map(el => {
        const scriptEl = el;
        return scriptEl.src;
    });
    const script_urls_new = script_urls.filter(x => !existing_scripts.includes(x));
    return Promise.all(script_urls_new.map(async (url) => new Promise((resolve, reject) => {
        const newScript = document.createElement('script');
        newScript.onerror = reject;
        newScript.onload = () => {
            resolve();
        };
        newScript.async = false;
        newScript.defer = false;
        newScript.type = 'application/javascript';
        document.head.appendChild(newScript);
        newScript.src = url;
    })));
};
export const addStylesToPage = async (stylesheets) => {
    const stylesheet_urls = _.map(stylesheets, x => {
        const prefix_char = x.indexOf('?') === -1 ? '?' : '&';
        x += `${prefix_char}_t=${window.rootData.Version}`;
        if (x[0] === '/') {
            x = `${location.protocol}//${location.host}${x}`;
        }
        return x;
    });
    return Promise.all(stylesheet_urls.map(async (x) => new Promise((resolve, reject) => {
        const newStyle = document.createElement('link');
        newStyle.onerror = reject;
        newStyle.onload = () => {
            resolve();
        };
        newStyle.classList.add('page-style');
        newStyle.rel = 'stylesheet';
        newStyle.type = 'text/css';
        document.head.appendChild(newStyle);
        newStyle.href = x;
    })));
};
const fixPageState = (s) => {
    const defaults = {
        contentPadding: true,
        cappedWidth: false,
        windowManager: null,
        hideSidebar: false,
        hideFooter: false,
        hideTopNav: false,
        collapseToIcon: false,
        toolbar: null,
        sidebarOverride: null,
        transparentBackground: false,
        legacyFrame: null,
        contextMenu: null,
        appName: 'main',
    };
    return _.assign(defaults, s);
};
window.onpopstate = ev => {
    if (window.rootUI == null) {
        return;
    }
    const stateID = ev.state?.id;
    const model = stateID != null && typeof stateID === 'number'
        ? historyModel.data[stateID]
        : undefined;
    if (model == null) {
        if (_.includes(location.pathname, 'client-portal') &&
            location.pathname !== '/client-portal/') {
            return;
        }
        openNavLinkMaybe(location.href);
        return;
    }
    if (typeof model === 'object' && model != null && 'contentDelta' in model) {
        const content = contentComponent();
        if (content != null) {
            const contentDelta = model.contentDelta;
            if (typeof contentDelta === 'object' && contentDelta != null) {
                content.setState(contentDelta);
            }
        }
        return;
    }
    if (model != null && typeof model === 'object') {
        const { url } = getUrlParts(location.href);
        changePageOuter(url, model);
        return;
    }
    console.info('Forcing page refresh from invalid pop history');
    location.reload();
};
const disablePageScroll = (e) => {
    e.preventDefault();
    e.returnValue = false;
    return false;
};
export const historyModel = {
    data: {},
    id: 0,
};
const pageStatePush = (data, url) => {
    const hd = historyModel;
    hd.data[hd.id] = data;
    history.pushState({ id: hd.id }, '', url);
    return hd.id++;
};
const pageStateReplace = (data, url) => {
    const hd = historyModel;
    hd.data[hd.id] = data;
    history.replaceState({ id: hd.id }, '', url);
    return hd.id++;
};
const refreshAppMetaData = (app) => {
    {
        const el = document.querySelector('link[rel="manifest"]');
        if (el != null) {
            const v = window._trionline_timestamp_version_value;
            const appName = app ?? 'main';
            const manifest_url = `/manifest-${appName}.json?_t=${v}`;
            const hrefAttr = el.attributes.getNamedItem('href');
            if (hrefAttr != null) {
                hrefAttr.value = manifest_url;
            }
        }
    }
    const qs = [
        'link[rel="icon"]',
        'link[rel="apple-touch-icon"]',
        'link[rel="shortcut icon"]',
        'meta[name="msapplication-TileImage"]',
    ];
    const q = qs.join(', ');
    const nodes = document.querySelectorAll(q);
    _.range(nodes.length).forEach(i => {
        const el = nodes.item(i);
        if (el == null) {
            return;
        }
        const key = Do(() => {
            if (el.tagName.toLowerCase() === 'meta') {
                return 'content';
            }
            return 'href';
        });
        const path = Do(() => {
            const appName = app ?? 'main';
            const sizeAttr = el.attributes.getNamedItem('data-size');
            const size = sizeAttr?.value;
            if (size != null) {
                return `/static/app-${appName}/m${size}.png`;
            }
            return `/static/app-${appName}/favicon.ico`;
        });
        const keyAttr = el.attributes.getNamedItem(key);
        if (keyAttr != null && path !== keyAttr.value) {
            keyAttr.value = path;
        }
    });
};
const showIEErrorPage = () => {
    document.body.innerText = '';
    document.body.appendChild(j2h({
        class: 'invalid-browser',
        children: [
            {
                children: [
                    {
                        tag: 'p',
                        text: 'Internet Explorer is not supported. Please use another browser.',
                    },
                    {
                        tag: 'p',
                        text: `For security reasons, TriOnline strongly recommends that you stop using Internet Explorer for all web browsing.`,
                    },
                    {
                        tag: 'ul',
                        children: [
                            { tag: 'li', text: 'Mozilla Firefox' },
                            { tag: 'li', text: 'Microsoft Edge' },
                            { tag: 'li', text: 'Google Chrome' },
                        ],
                    },
                ],
                attr: {
                    style: `padding: 10px; font: 24px 'Roboto', 'Arial', 'Sans-Serif';`,
                },
            },
        ],
        attr: {
            style: `
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: white;`,
        },
    }));
};
const showOutdatedBrowserPage = () => {
    document.body.innerText = '';
    document.body.appendChild(j2h({
        class: 'invalid-browser',
        children: [
            {
                children: [
                    {
                        tag: 'p',
                        text: 'You are using an outdated browser that is not supported. Please use another browser.',
                    },
                    {
                        tag: 'p',
                        text: `For security reasons, TriOnline strongly recommends that you stop using this browser and consider the following:`,
                    },
                    {
                        tag: 'ul',
                        children: [
                            { tag: 'li', text: 'Mozilla Firefox' },
                            { tag: 'li', text: 'Microsoft Edge' },
                            { tag: 'li', text: 'Google Chrome' },
                        ],
                    },
                ],
                attr: {
                    style: `\
							padding: 10px;
							font: 24px 'Roboto', 'Arial', 'Sans-Serif';
						`,
                },
            },
        ],
        attr: {
            style: `
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: white;
				`,
        },
    }));
};
const TriOnlineFrameSidebar = (props) => (React.createElement("div", { id: "hub_sidebar", className: BuildClass({
        [props.getResponsiveClassName()]: true,
        noselect: true,
        hiddenDefault: props.hideSidebar,
        employee: (window.rootData.Session?.Authority ?? 0) === 0,
        open: props.sidebarOpen,
    }) }, Do(() => {
    if (props.sidebar == null) {
        return React.createElement(J2rLoadingSpinner, { size: "large" });
    }
    if (props.sidebarOverride != null) {
        const override = props.sidebarOverride();
        if (override != null) {
            return override;
        }
    }
    return (React.createElement(React.Fragment, null, _.map(props.sidebar, (item, index) => [
        React.createElement(TriOnlineSidebarItem, { key: index, item: {
                Label: item.Label,
                Link: item.Link,
                Children: item.Children,
            }, expandedSidebar: props.expandedSidebar, onToggleExpanded: props.onToggleExpanded }),
    ])));
})));
const TriOnlineSidebarItem = (props) => (React.createElement(React.Fragment, null,
    React.createElement("a", { key: props.item.Label, className: BuildClass({
            selected: compareLinks(props.item.Link, location.pathname),
            open: props.expandedSidebar === props.item.Label,
        }), href: props.item.Link ?? undefined, title: props.item.Label, onClick: props.item.Link != null && props.item.Link !== ''
            ? appLinkEv
            : (ev) => {
                ev.preventDefault();
                props.onToggleExpanded(Do(() => {
                    if (props.expandedSidebar === props.item.Label) {
                        return null;
                    }
                    return props.item.Label;
                }));
            } },
        React.createElement("img", { key: "arrow", alt: props.item.Children != null ? 'Expanded' : 'Not expanded', src: "/static/img/svg/triangle-down.svg", style: {
                visibility: Do(() => {
                    if (props.item.Children != null) {
                        return 'visible';
                    }
                    return 'hidden';
                }),
            } }),
        React.createElement("span", { key: "lbl", title: props.item.Label }, props.item.Label)),
    ConditionalObject(props.expandedSidebar === props.item.Label, () => (React.createElement(React.Fragment, null, _.map(props.item.Children, sub => (React.createElement("a", { key: sub.Label, className: BuildClass({
            sub: true,
            selected: compareLinks(sub.Link, location.pathname),
        }), href: sub.Link ?? null, onClick: appLinkEv, title: sub.Label, style: { display: 'block' } }, sub.Label))))))));
//# sourceMappingURL=component-frame.js.map